import { apiV2 } from "../v2";
import {
  adminArticleStatsRequest,
  adminArticleStatsResponse,
  adminAuthorStatsRequest,
  adminAuthorStatsResponse,
  adminRequestCountsRequest,
  adminRequestCountsResponse,
} from "./stats.dto";

export const getAdminArticleStatsApi = apiV2("GET", "/admin/stats/article-stats").withRequest(adminArticleStatsRequest).withResponse(adminArticleStatsResponse);

export const getAdminAuthorStatsApi = apiV2("GET", "/admin/stats/author-stats").withRequest(adminAuthorStatsRequest).withResponse(adminAuthorStatsResponse);

export const getAdminRequestCountsApi = apiV2("GET", "/admin/stats/requests").withRequest(adminRequestCountsRequest).withResponse(adminRequestCountsResponse);
